import { PortfolioService, ListingModalService, ContentService, ShepherdService } from '@DavisDigital/davisdigitalfrontend.module';

import {
	Folder,
	FoldersAPIResponse,
	FolderTypes,
	Portfolio,
	PortfoliosAPIResponse,
	SortingOptions,
} from '@DavisDigital/interfaces';

import * as Shepherd from '../../../../../org/Hibachi/client/lib/shepherd.js/dist/js/shepherd.min.js'

enum PortfolioTab {
	MY_PORTFOLIOS = 'myPortfolios',
	STUDENTS = 'myStudentsPortfolios',
	SHARED = 'sharedPortfolios',
	DISTRICT = 'myDistrictPortfolios',
	FEATURED = 'featuredPortfolios',
}

class PortfolioListingState {
	public isLoading = false;

	public createPortfolio = false;

	public hideFolders = false;
	public selectedFolder: Folder = undefined;

	public recordsPerPage = 8;
	public recordsFolderPerPage = 4;
	public searchKeywords: string; // whatever visible in the UI
	public selectedSearchKeywords: string; // whatever is selected

	public selectedFolderID:string;
	public sortingOptions = SortingOptions;
	public sortOrder = 1; // ehatever is visible in the UI
	public selectedSortOrder = 1; // currently selected sort order
	public sharedByAccount: string = "";

	public activeTab: PortfolioTab = PortfolioTab.MY_PORTFOLIOS;
	public activeTabTitle = 'My Portfolios';

	public activeFolders: Folder[];
	public activeFoldersCurrentPage = 1;
	public activeFoldersPageCount: number;
	
	public accountSharerList = [];
	public activePortfolios: Portfolio[];
	public activePortfoliosImages:[];
	public activePortfoliosCurrentPage = 1;
	public activePortfoliosPageCount: number;
	public displayFirstTimeLanding:boolean;
	
	public constructor(public $location: ng.ILocationService) {}

	public setLoading = (isLoading: boolean) => {
		this.isLoading = isLoading;
	};

	public setActivePortfolios = (portfolios: Portfolio[], pageCount?: number,portfoliosImage?: any) => {
		this.activePortfolios = portfolios;
		this.activePortfoliosPageCount = pageCount || 1;
		this.activePortfoliosImages = portfoliosImage;
	};
	public setActivePortfoliosCurrentPage = (pageNumber: number) => {
		this.activePortfoliosCurrentPage = pageNumber;
	};
	
	public setAccountSharerList = (accountSharerList = []) => {
		this.accountSharerList = accountSharerList;
	}
	
	public setActiveFolders = (folders: Folder[], pageCount?: number) => {
		
		this.activeFolders = folders;
		this.activeFoldersPageCount = pageCount || 1;
		
		if(this.activeFolders?.length === 1 && this.activeFolders[0].folderID === this.selectedFolderID){
			this.setSelectedFolder(this.activeFolders[0]);
		}
	};
	public setActiveFoldersCurrentPage = (pageNumber: number) => {
		this.activeFoldersCurrentPage = pageNumber;
	};
	public setSelectedFolder(folder?: Folder) {
		this.selectedFolder = folder;
		this.$location.search('folderID', folder?.folderID);
		this.setHideFolders(!!folder);
	}
	public setHideFolders(hide: boolean) {
		this.hideFolders = hide;
	}

	public applySearchKeywordsChange = () => {
		if (this.selectedSearchKeywords !== this.searchKeywords) {
			this.selectedSearchKeywords = this.searchKeywords;
			return true;
		}
		return false;
	};

	public applySortOrderChange() {
		if (this.selectedSortOrder !== this.sortOrder) {
			this.selectedSortOrder = this.sortOrder;
			return true;
		}
		return false;
	}

	public setActiveTab(selectedTab?: PortfolioTab) {
		
		if (this.activeTab === selectedTab && this.selectedFolderID == null) return false;

		this.activeTab = selectedTab;
		this.selectedFolderID = undefined;
		this.selectedFolder = undefined;
		this.searchKeywords = undefined;
		this.selectedSearchKeywords = undefined;
		
		//Remove order 5 from existing sorting options
		this.sortingOptions = this.sortingOptions.filter(item => item.order !== 5);
		
		switch (selectedTab) {
			case PortfolioTab.MY_PORTFOLIOS:
				this.activeTabTitle = 'My Portfolios';
				break;
			case PortfolioTab.STUDENTS:
				this.activeTabTitle = 'My Students';
				this.sortingOptions.push({ order: 5, text: 'Author' });
				break;
			case PortfolioTab.SHARED:
				this.activeTabTitle = 'Shared With Me';
				break;
			case PortfolioTab.DISTRICT:
				this.activeTabTitle = 'My District';
				break;
			case PortfolioTab.FEATURED:
				this.activeTabTitle = 'Featured';
				break;
		}

		return true;
	}
}

class PortfolioListingController {
	//Create new Lesson
	public slatwall: any;
	public state$: PortfolioListingState;
	public permissions;
	public displayFirstTimeLanding: boolean;
	
	// @ngInject
	constructor(
		private $q: ng.IQService,
		private $timeout: ng.ITimeoutService,
		public $rootScope: ng.IRootScopeService,
		private $location: ng.ILocationService,
		private portfolioService: PortfolioService,
		private listingModalService: ListingModalService,
		private contentService: ContentService,
		public shepherdService: ShepherdService
	) {
		this.state$ = new PortfolioListingState($location);
	}

	public $onInit = () => {
		let portfolioPageID = this.$location.search().portfolioPageID;
		if (portfolioPageID?.length === 32) {
			this.state$.createPortfolio = true;
		}

		var folderID = this.$location.search().folderID; 
		if(folderID?.length === 32){
			this.state$.selectedFolderID = folderID;
		}

		this.getPortfolios();
		this.getFolders();

		//selectpicker doesn't pick changes from ng-options automatically
		this.$timeout(() => $('.selectpicker').selectpicker('refresh'));
	};

	
	// UI events handlers

	public onCreateFolder() {
		let folderType = FolderTypes.Portfolio
		switch (this.state$.activeTab) {
			case PortfolioTab.STUDENTS:
				folderType = FolderTypes.MyStudentsPortfolio;
				break;
			case PortfolioTab.SHARED:
				folderType = FolderTypes.MySharedWithMePortfolio;
				break;
		}

		this.listingModalService.launchAddEditFolderModal(
			folderType,
			undefined,
			undefined,
			(success) => {
				if (success) this.getFolders(false, true);
			},
		);
	}

	public onCreatePortfolio() {
		this.state$.createPortfolio = !this.state$.createPortfolio;
		this.shepherdService.initShepherdPortfolioCreate();
	}

	public onSortOrderChange() {
		if (this.state$.applySortOrderChange()) {
			this.refreshFoldersAndPortfolios(true, true);
		}
	}
	
	public onSearchSharedByAccount() {
		this.refreshFoldersAndPortfolios(true, true);
	}

	public onSearch = () => {
		if (this.state$.applySearchKeywordsChange()) {
			this.refreshFoldersAndPortfolios();
		}
	};

	private tabIdToKey: { [id: string]: PortfolioTab } = {
		'MyPortfolio-tab': PortfolioTab.MY_PORTFOLIOS,
		'MyStudents-tab': PortfolioTab.STUDENTS,
		'PortfoliosShared-tab': PortfolioTab.SHARED,
		'MyDistrict-tab': PortfolioTab.DISTRICT,
		'Featured-tab': PortfolioTab.FEATURED,
	};

	public onTabKeydown = ($event: KeyboardEvent) => {
		const currentTab = $event.currentTarget as HTMLElement;
		const tabList = currentTab.closest('[role="tablist"]') as HTMLElement;
		if (!tabList) return;

		const tabs = Array.from(tabList.querySelectorAll('[role="tab"]')) as HTMLElement[];
		const currentIndex = tabs.indexOf(currentTab);

		if (currentIndex === -1) return;

		let newIndex: number;

		switch ($event.key) {
			case 'ArrowRight':
				newIndex = (currentIndex + 1) % tabs.length;
				break;
			case 'ArrowLeft':
				newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
				break;
			case 'Home':
				newIndex = 0;
				break;
			case 'End':
				newIndex = tabs.length - 1;
				break;
			case 'Enter':
			case ' ':
				$event.preventDefault();
				const tabKey = this.tabIdToKey[currentTab.id];
				if (tabKey) {
					this.onTabChange(tabKey, tabKey === PortfolioTab.MY_PORTFOLIOS);
				}
				return;
			default:
				return;
		}

		$event.preventDefault();
		tabs[newIndex].focus();
	};

	public onTabChange = (selectedTab: PortfolioTab, removeFolder = false ) => {
		
		if(selectedTab == "sharedPortfolios" || selectedTab == "myStudentsPortfolios"){
			this.contentService.getSharerAccountList('portfolio', (selectedTab == "myStudentsPortfolios" ? 2 : 0), true
			).then((response) => {
				this.state$.setAccountSharerList(response.data);
			});
		} else {
			this.state$.setAccountSharerList();
		}
		
		if (this.state$.setActiveTab(selectedTab) || removeFolder) {
			
			this.state$.setSelectedFolder(null);
			
			//Hide folders view for district and featured tab
			this.state$.hideFolders = (PortfolioTab.DISTRICT === this.state$.activeTab || PortfolioTab.FEATURED === this.state$.activeTab);
			this.refreshFoldersAndPortfolios(true, true);
		}
	};

	public onActivePortfoliosCurrentPageChange = (pageNumber: number) => {
		this.state$.setActivePortfoliosCurrentPage(pageNumber);
		this.getPortfolios(false);
	};

	public onActiveFoldersCurrentPageChange = (pageNumber: number) => {
		this.state$.setActiveFoldersCurrentPage(pageNumber);
		this.getFolders(false);
	};

	public onFolderSelected = (folder: Folder) => {
		this.state$.setSelectedFolder(folder);
		this.state$.setActiveFolders([]);
		this.getPortfolios(true, true);
	};

	public onRemoveSelectedFolder = () => {
		this.state$.setSelectedFolder(undefined);
		this.refreshFoldersAndPortfolios(true, true);
	};

	private refreshFoldersAndPortfolios = (resetCurrentPage = true, bustCache = false) => {
		this.getPortfolios(resetCurrentPage, bustCache);
		this.getFolders(resetCurrentPage, bustCache);
	};
	

	// API callbacks

	private onFoldersReceived = (response: FoldersAPIResponse) => {
		this.state$.setLoading(false);
		if (response?.data?.records) {
			this.state$.setActiveFolders(response.data.records, response.data.totalPages);
		}
		//TODO: success/failure
	};

	private onPortfolioReceived = (response: any) => {
		this.state$.setLoading(false);
		
		if (response?.permissions){
			this.permissions = response.permissions;
		}
		
		if (response?.data?.records) {
			this.state$.setActivePortfolios(response.data.records, response.data.totalPages,response.data.imageMap);
		} else {
			//TODO: success/failure
		}
	};

	private getPortfolios = (resetCurrentPage = true, bustCache = false): any => {
		this.state$.setLoading(true);
		if (resetCurrentPage) {
			this.state$.setActivePortfoliosCurrentPage(1);
		}

		let data = {
			currentPage: this.state$.activePortfoliosCurrentPage,
			recordsPerPage: this.state$.recordsPerPage,
			keywords: this.state$.selectedSearchKeywords,
			folderID: this.state$.selectedFolderID,
			folder: this.state$.selectedFolder,
			sortOrder: this.state$.selectedSortOrder,
			bustCache: bustCache,
			sharedByAccount: this.state$.sharedByAccount,
		};

		if (PortfolioTab.MY_PORTFOLIOS === this.state$.activeTab) {
			this.portfolioService.getMyPortfolios(data).then(this.onPortfolioReceived);
		}

		if (PortfolioTab.SHARED === this.state$.activeTab) {
			if(this.state$.selectedFolder && this.state$.selectedFolder.folderType_systemCode != FolderTypes.Portfolio){
				this.portfolioService.getFolderItems(data).then(this.onPortfolioReceived);
			}else{
				this.portfolioService.getSharedPortfolios(data).then(this.onPortfolioReceived);
			}
		}
		
		if (PortfolioTab.STUDENTS === this.state$.activeTab) {
			if(this.state$.selectedFolder && this.state$.selectedFolder.folderType_systemCode != FolderTypes.Portfolio){
				this.portfolioService.getFolderItems(data).then(this.onPortfolioReceived);
			}else{
				this.portfolioService.getStudentPortfolios(data).then(this.onPortfolioReceived);
			}
		}
		
		if (PortfolioTab.DISTRICT === this.state$.activeTab) {
			this.portfolioService.getDistrictPortfolios(data).then(this.onPortfolioReceived);
		}
		
		if (PortfolioTab.FEATURED === this.state$.activeTab) {
			this.portfolioService.getFeaturedPortfolios(data).then(this.onPortfolioReceived);
		}
	};

	private getFolders = (resetCurrentPage = true, bustCache = false): any => {
		
		//Hide Folders
		if (this.state$.hideFolders) {
			this.state$.activeFolders = [];
			return;
		}

		this.state$.setLoading(true);
		
		if (resetCurrentPage) {
			this.state$.setActiveFoldersCurrentPage(1);
			//reset folders array if we're resetting pagination
			this.state$.activeFolders = [];
		}

		let data = {
			currentPage: this.state$.activeFoldersCurrentPage,
			recordsPerPage: this.state$.recordsFolderPerPage,
			sortOrder: this.state$.selectedSortOrder,
			keywords: this.state$.searchKeywords,
			bustCache: bustCache,
			sharedByAccount: this.state$.sharedByAccount
		};
		
		if(this.state$?.selectedFolderID?.length === 32){
			data['folderID'] = this.state$.selectedFolderID;
		}

		if (PortfolioTab.MY_PORTFOLIOS === this.state$.activeTab) {
			data['folderType'] = FolderTypes.Portfolio;
			this.portfolioService.getMyPortfolioFolders(data).then(this.onFoldersReceived).finally(()=>{
				this.shepherdService.initShepherdPortfolioMain(this.displayFirstTimeLanding);
			});
		}
		// todo : this needs needs to be combined to one call...
		if (PortfolioTab.SHARED === this.state$.activeTab) {
			data['folderType'] = FolderTypes.MySharedWithMePortfolio;
			this.portfolioService.getSharedPortfolioFolders(data).then(this.onFoldersReceived);
		}

		if (PortfolioTab.STUDENTS === this.state$.activeTab) {
			data['folderType'] = FolderTypes.MyStudentsPortfolio;
			this.portfolioService.getStudentsPortfolioFolders(data).then(this.onFoldersReceived);
		}
	};
	
	//Featured Portfolios
	private getFeaturedPortfolios = (resetCurrentPage = true, bustCache = false): any => {
		this.state$.setLoading(true);
		if (resetCurrentPage) {
			this.state$.setActivePortfoliosCurrentPage(1);
		}

		let data = {
			currentPage: this.state$.activePortfoliosCurrentPage,
			recordsPerPage: this.state$.recordsPerPage,
			keywords: this.state$.selectedSearchKeywords,
			folder: this.state$.selectedFolder,
			sortOrder: this.state$.selectedSortOrder,
			bustCache: bustCache,
		};
		
		this.portfolioService.getFeaturedPortfolios(data).then(this.onPortfolioReceived)
		.finally(()=>{
			this.$timeout(()=>{
				this.initFeaturedSlider(); 
				this.setSlickSliderHeight('.slick-slide');
				this.setSlickSliderHeight('.card__tile__copy')
			}, 500)});
	};
	
	public initFeaturedSlider = () => {
	  	$('.featured-slider').slick({
			infinite: true,
			speed: 500,
			slidesToShow: 4,
			slidesToScroll: 4,
			prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="fas fa-chevron-left"></i></button>',
			nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="fas fa-chevron-right"></i></button>',
			responsive: [
			{
			  breakpoint: 1199,
			  settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
			  }
			},
			{
			  breakpoint: 991,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			  }
			},
			{
			  breakpoint: 767,
			  settings: "unslick"
			}
		  ]
		});
	 }
	  
	public setSlickSliderHeight = (classElement) => {
		let slickSliderHeight = 0;
		let slickSliderMaxHeight = 0;
		$(classElement).each(function(){
			slickSliderHeight = $(this).outerHeight();
			if(slickSliderHeight >= slickSliderMaxHeight){
				slickSliderMaxHeight = slickSliderHeight;  
			}
		});
		$(classElement).innerHeight(slickSliderMaxHeight);
	}
}

export { PortfolioListingController };